import React from 'react';
import PropTypes from 'prop-types';
import './TSILDisclosureModal.css';

function TSILDisclosureModal({ isVisible, onContinue }) {
  if (!isVisible) return null;

  return (
    <div className="tsil-modal-overlay">
      <div className="tsil-modal-container">
        <div className="tsil-modal-box">
          <h2 className="tsil-modal-title">
            UK RESIDENTS PLEASE READ:
          </h2>
          <div className="tsil-modal-content">
            <p>
              UK residents applying to TradeStation Securities Inc. (&ldquo;TSS&rdquo;) for brokerage and trading services
              have been introduced by TradeStation International Limited (&ldquo;TSIL&rdquo;), a firm authorized and regulated
              by the Financial Conduct Authority (&ldquo;FCA&rdquo;) in the UK. TSIL does not offer any brokerage or trading
              services. The provision of any brokerage or trading services by TSS (&ldquo;TSS&rsquo; Services&rdquo;) shall
              be on such terms as you may agree directly with TSS.
              <br /><br />
              TSS&rsquo; Services are intended for self-directed investors making their own investment decisions without TSS
              providing investment advice. TSS offers customers the opportunity to trade a range of asset classes with different
              levels of risk and complexity. More complex and higher-risk asset classes should only be considered by experienced
              investors with a deep understanding of financial markets, complex products, their risk tolerance, and risk
              management techniques. Trading complex products or high-risk asset classes can result in an investor losing more
              than their initial capital investment.
              <br /><br />
              You should not open a TSS account if you desire investment management or advisory services, you do not wish to
              take on any investment risk, or you cannot risk losing your capital investment (or more with complex products and
              margin trading). You should be willing to take the time to understand and research your investment choices and
              the risks involved in them and monitor the performance of your investments on a regular basis. Before investing,
              you should be confident that you understand which asset classes carry comparatively lower risk and those which
              are more complex and high-risk.
              <br /><br />
              For more information, please review the &ldquo;Disclosures and Terms of Business for UK Residents&rdquo; in the
              &ldquo;Setting & Agreements&rdquo; section of this process.
              <br /><br />
              IF YOU HAVE ANY QUESTIONS REGARDING TSIL&rsquo;S INTRODUCTORY SERVICES OR THE DISCLOSURE PROVIDED ABOVE, EMAIL
              TSIL AT: international@tradestation.com
            </p>
          </div>
          <button className="tsil-modal-continue" onClick={onContinue}>
            Continue
          </button>
        </div>
      </div>
    </div>
  );
}

TSILDisclosureModal.propTypes = {
  isVisible: PropTypes.bool.isRequired,
  onContinue: PropTypes.func.isRequired,
};

export default TSILDisclosureModal;
